module.exports = __webpack_public_path__ + "img/image (57).0567ff0a.jpg";